module.exports = __webpack_public_path__ + "static/img/4.9e5a1124.png";